export default {
    namespaced: true,

    state: {
        horoscope: null
    },

    mutations: {
        setHoroscope(state, horoscope) {
            state.horoscope = horoscope;
        }
    },

    getters: {
        getHoroscope: ((state) => {
            return state.horoscope;
        }),
    }
};